'use client'

import { useRouter } from 'next/navigation'

import { Pagination } from '@/components/ui/pagination'

type SearchPaginationProps = {
  numResults: number
  resultsPerPage: number
  currentPage: number
  query: string
}

export const SearchPagination: React.FC<SearchPaginationProps> = ({
  numResults,
  resultsPerPage,
  currentPage,
  query,
}) => {
  const router = useRouter()

  const onPageChange = (nextPage: number) => {
    const params = new URLSearchParams()
    if (query) params.set('q', query)
    if (nextPage > 1) params.set('page', String(nextPage))
    const qs = params.toString()
    router.push(qs ? `/search?${qs}` : '/search')
  }

  return (
    <Pagination
      numResults={numResults}
      resultsPerPage={resultsPerPage}
      currentPage={currentPage}
      onPageChange={onPageChange}
    />
  )
}
